import { render } from "./EditModelParameters.vue?vue&type=template&id=29f21d20&ts=true"
import script from "./EditModelParameters.vue?vue&type=script&lang=ts"
export * from "./EditModelParameters.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__